import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { SystemModel, UCSystemType, Side, UpdateComponentMeasurementModel, MeasurementType, ComponentModel, QuoteOverviewModel, InspectionMeasurement, InspectionMeasurementVM } from '../../models/interpretation.model';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog'; import { AddRecommendationComponent } from '../add-recommendation/add-recommendation.component';
import { QuoteService } from '../../quote-service.service';
import { UserService } from '../../../../shared/services/user.service';
import { LoadingService } from '../../../../shared/services/loading.service';
import { AppService } from '../../../../../app/app.service';
import { SetupUndercarriageService } from '../../../../modules/setup-undercarriage';
import { TranslateService } from '../../../../translate';
import { CustomeEvaluationRangeVM } from '../../../../../app/modules/CustomEval/custom-eval.model';
import { TrackFrameConfigurationComponent } from '../.,/../../../../../app/modules/manage-equipment/components/track-frame-configuration/track-frame-configuration.component';
import { MultiplePhotoUploadComponent } from '../multiple-photo-upload/multiple-photo-upload.component';
import { EditSystemSerialNumberComponent } from '../edit-system-serial-number/edit-system-serial-number.component';
import { EditRecommendationComponent } from '../edit-recommendation/edit-recommendation.component';
import { ViewMultipleMeasurementsComponent } from '../view-multiple-measurements/view-multiple-measurements.component';
import { ViewFlaggedComponentInfoComponent } from '../view-flagged-component-info/view-flagged-component-info.component';
import { PreferencesService } from '../../../../modules/preferences/preferences.service';
import { ScreenCode, toolType, toolTypePassFail, toolTypeYesNo } from '../../../../shared/enums/allEnums';
import { ComponentImageHistoryComponent } from '../component-image-history/component-image-history.component';
import { PopupEndPoint } from '../../../../../app/modules/inspection/models/create-inspection.model';

@Component({
  selector: 'system',
  templateUrl: './system.component.html',
  styleUrls: ['./system.component.scss'],
  animations: [
    trigger(
      'slideOut', [
      transition(':enter', [
        style({ 'max-height': '0' }),
        animate('5s', keyframes([
          style({ 'max-height': '200px', offset: 0 }),
          style({ 'max-height': '400px', offset: 0.3 }),
          style({ 'max-height': '600px', offset: 0.6 }),
          style({ 'max-height': '1400px', offset: 0.9 }),
        ]))
      ])
    ]
    )],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SystemComponent implements OnInit, AfterViewInit {
  @Input() inspectionId: number = -1;
  @Input() systemId: number = -1;
  @Input() selectedQuoteId: number = -1;

  @Input() Family_: string
  @Input() FamilyImage_Frame: string

  @Input() FamilyImage_Chain: string

  @Input() equipmentID: number;
  @Input() ShowHideCRoller: boolean;

  @Input() showDistTravelledTracking: boolean;
  @Input() showCMU: boolean;
  @Input() showResLife100: boolean;
  @Input() showResLife120: boolean;
  @Input() showDOC: boolean;
  @Input() showResDOC100: boolean;
  @Input() showResDOC120: boolean;
  @Input() editComponentType: boolean;
  updateComment: string;
  @Output() reloadSelectedQuote: EventEmitter<any> = new EventEmitter();
  @Output() reloadFlaggedComponents: EventEmitter<any> = new EventEmitter();

  @Output() sendToParent: EventEmitter<any> = new EventEmitter();


  @Output() measurementPointUpdated = new EventEmitter();
  @Output() ComponentCommentUpdated = new EventEmitter();

  @Input() isParentChanged: boolean;
  // @Output() systemChanged = new EventEmitter<void>();

  quotes: QuoteOverviewModel[] = [];
  system: SystemModel = new SystemModel();
  loadingSystems = true;
  side = 'Left';
  type = 'Chain';
  isInspector = false;
  isInterpreter = false;

  _inspectionId: number = -1;
  overallEval = 'U';
  overallEvalLoading = true;
  removeFlagPopup = false;
  userLanguage: string = "english";
  flag_comment: string = "";
  flag_on: boolean = false;
  selected_inspection_detail_auto: number;
  selected_track_unit_auto: number;
  glb_LocalIncpectionid: any;
  @Input() InspectionSMU: number;
  @Input() EvalautionRange: CustomeEvaluationRangeVM;
  editableSystemBudgetLife: boolean = false;
  editableSysBudgetDistance: boolean = false;
  userUOD: string = 'km';
  toolType = toolType;
  toolTypeYesNo = toolTypeYesNo;
  toolTypePassFail = toolTypePassFail;
  showFrameConfigurattion: boolean = false;
  showCannonType: boolean = false;
  enableBogieShim: boolean = false;
  userUOM: string;
  screenCode = ScreenCode;
  constructor(
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,
    private _dialog: MatDialog,
    private _quotes: QuoteService,
    private _cdr: ChangeDetectorRef,
    private _user: UserService,
    private _appService: AppService,
    private _loading: LoadingService,
    private _setupService: SetupUndercarriageService,
    private _translate: TranslateService,
    private _app: AppService,
    private _pref: PreferencesService
  ) { }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
              this.isInspector = true;
              break;
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
            case 'Undercarriage ONLY':
            case 'Undercarriage Inspector ONLY':
              this.isInspector = true;
              break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }
  UTEquivalenetEnabled: boolean = false;
  UTEqu: string;
  isEnableMaxRange: boolean;
  ngOnInit() {
    //var _childrefresh= false;
    this.checkPermissions();
    this.getUserUOD();
    //if(!_childrefresh)
    if (!this.isParentChanged) {
      this.loadSystem();
    }
    this.loadQuotes();
    this._app.getApplicationConfigValue("UTEquivalentEnabled").subscribe(result => {
      this.UTEqu = result
      if (this.UTEqu == "1") {
        this.UTEquivalenetEnabled = true;

      } else {
        this.UTEquivalenetEnabled = false;
      }

    });


    this._app.getApplicationConfigValue("EnableMaxRangeForEvaluation").subscribe(result => {

      if (result == "1") {
        this.isEnableMaxRange = true;
      } else {
        this.isEnableMaxRange = false;
      }
    });
  }

  ngOnChanges() {
    /**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
    //Write your code here
    console.log('isParentChanged - ', this.isParentChanged);
    if (this.isParentChanged) {
      this.isParentChanged = false;
      this.loadSystem();
    }
  }
  onToolOptionSelect(component: ComponentModel, value: number) {
    if (value === toolTypeYesNo.Yes || value === toolTypePassFail.Pass) {
      this.updateComponentMeasurement(value, component.InspectionDetailId, null, component);
    }
    else {
      this.updateComponentMeasurement(value, component.InspectionDetailId, null, component);
    }
  }
  //
  GetEvalColour(comp: ComponentModel, worn: number) {
    if (this.EvalautionRange == null)
      return 'Eval-U';
    var compType = comp.ComponentTypeId;
    if (comp.Measurement === -1 || comp.ToolId === toolType.YESorNO || comp.ToolId === toolType.PassorFail) {
      return 'Eval-U';
    }
    if (comp.ToolId === toolType.ConditionAssessment) {
      if (comp.EvalCode === 'A') return 'Eval-A';
      else if (comp.EvalCode === 'B') return 'Eval-B';
      else if (comp.EvalCode === 'X') return 'Eval-X';
    }
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 237://Idler

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';


      default:
        break;
    }
  }


  viewComponentPhoto(photoId: number, inspectionDetailId: number, component: ComponentModel, ComingFrom?: number, systemId?: number) {
    //console.log("id__1",photoId)
    //const viewPhotoModalRef = this._dialog.open(ViewPhotoComponent, {
    const viewPhotoModalRef = this._dialog.open(MultiplePhotoUploadComponent, {
      width: '800px',
      disableClose: true,
      //panelClass: 'custom-dialog-panel',  
      data: {
        inspectionId: this.inspectionId,
        photoId: photoId,
        inspectionDetailId: inspectionDetailId,
        IsImageUrl: true,
        ScreenId: 7,
        comingFrom: ComingFrom,
        systemId: systemId
      }
    });
    viewPhotoModalRef.afterClosed().subscribe(r => {
      if (!r) return;

      if (r.comingFrom === PopupEndPoint.SystemInspectionImages) {
        this.systemId = r.SystemId;
        this.loadSystem();
      } else {
        this.loadPhoto(component);
      }
    });
  }

  viewComponentHistoryPhoto(component: ComponentModel, IsSystemImages:boolean=false, system:any=null) {
    const viewPhotoModalRef = this._dialog.open(ComponentImageHistoryComponent, {
      width: '1300px',
      panelClass: 'custom-dialog-panel',
      data: {
        equipmentID: this.equipmentID,
        comparttypeid: component?.ComponentTypeId,
        position: component?.Pos,
        side: component?.Side,
        name: component?.Name,
        IsSystemImages: IsSystemImages,
        system: system,
        IsInterp: true
      }
    });
  }

  openAddEditRecommendation(componentId: number, RecommendationId: number) {
    this.openAddRecommendation(componentId);
    //   //debugger;
    //   //if(RecommendationId == 0){
    //   //  this.loadQuotes();
    //   //  RecommendationId = this.componentRecommendationId(componentId);
    //   //}
    //   //console.log("recommendationId:" + RecommendationId.toString() + "quote: " + this.selectedQuoteId.toString());
    //   var tf = this.componentHasRecommendation(componentId);
    //  this.glb_LocalIncpectionid= localStorage.getItem('LocalIncpectionid');  //use for local storage.
    //  if(this.glb_LocalIncpectionid==RecommendationId)
    //  {
    //   this.openAddRecommendation(componentId);
    // //  return;
    //  }
    //  // console.log("recommendationId:" + RecommendationId.toString() + "quote: " + this.selectedQuoteId.toString());
    //  else if(RecommendationId > 0)
    //  {
    //     this.openEditRecommendation(componentId, RecommendationId);
    //  }
    //   else
    //   {
    //     this.openAddRecommendation(componentId);
    //   }
  }

  openAddRecommendation(componentId: number) {
    const addRecommendationModalRef = this._dialog.open(AddRecommendationComponent, {
      data: {
        inspectionId: this.inspectionId,
        componentId: componentId,
        quoteId: this.selectedQuoteId,
        inspectionSMU: this.InspectionSMU,
      }
    });
    addRecommendationModalRef.afterClosed().subscribe(details => {
      if (details != null) {
        this._quotes.reloadQuoteOverview(this.inspectionId);
        this.loadSystem();
        this.reloadSelectedQuote.emit(details)
      }
    });
  }

  openEditRecommendation(componentId: number, recommendationId: number) {
    let editRecommendationModalRef = this._dialog.open(EditRecommendationComponent, {
      data: {
        inspectionId: this.inspectionId,
        componentId: componentId,
        quoteId: this.selectedQuoteId,
        recommendationId: recommendationId//,
        //recommendation: this.recommendation
      }
    });
    editRecommendationModalRef.afterClosed().subscribe(details => {
      if (details != null) {
        this._quotes.reloadQuoteOverview(this.inspectionId);
        this.loadSystem();
        this.reloadSelectedQuote.emit(details)
      }
    })
  }

  openTrackCofiguration(selectedType: number, selectedValue: number, systemIds: number, Side: number) {
    const dialogRef = this._dialog.open(TrackFrameConfigurationComponent, {
      disableClose: true,
      width: '1032px',
      data: {
        selectedType: selectedType,
        selectedValue: selectedValue,
        systemId: systemIds,
        equipmentId: this.equipmentID,
        inspectionId: this.inspectionId,
        screenId: ScreenCode.IP
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      //console.log("system", this.system)

      if (selectedType == 1) {
        this.system.ToeOutFrame = res;
        window.location.reload();
        //this.sendToParent.emit(true);
        if (selectedValue != res) {
          //need to update 
        }
        //console.log("system__", this.system)
      } else {
        this.system.CastFrame = res;
        if (selectedValue != res) {
          //need to update 
        }
        //console.log("system++++", this.system)
      }


    });
  }
  //   someMethod() {
  //   this.systemChanged.emit();
  // }

  inspectionMeasurement: InspectionMeasurement[] = [];
  InspectionMeasurementVM: InspectionMeasurementVM;

  loadSystem() {
    this.inspectionMeasurement = [];
    this.InspectionMeasurementVM = new InspectionMeasurementVM();
    this._interp.getSystem(this.inspectionId, this.systemId).subscribe(system => {
      //console.log("s",system)
      this.system = system;
      this.loadingSystems = false;
      this.showFrameConfigurattion = this.system.Components[0].EnableFrameConfiguration;
      this.showCannonType = this.system.Components[0].EnableCannonType;
      this.enableBogieShim = this.system.Components[0].EnableBogieShim;
      console.log('enableBogieShim', this.enableBogieShim);
      this._cdr.detectChanges();


      this.system.Components.forEach(x => {
        let inspectionMeasurement = new InspectionMeasurement();

        inspectionMeasurement.CompartId = x.CompartId_Auto;
        inspectionMeasurement.EquipmentId = this.equipmentID;
        inspectionMeasurement.InspectionDetailId = x.InspectionDetailId;
        inspectionMeasurement.Measurement = x.Measurement;
        inspectionMeasurement.ToolId = x.ToolId;
        inspectionMeasurement.InspectionId = this.inspectionId;
        inspectionMeasurement.Side = x.Side;
        inspectionMeasurement.Position = x.Pos;
        this.inspectionMeasurement.push(inspectionMeasurement);
      }
      );
      this.InspectionMeasurementVM.InspectionMeasurement = [];
      this.InspectionMeasurementVM.InspectionMeasurement = this.inspectionMeasurement;
      this.UpdateComponentMeasurementRefreshInperp(this.InspectionMeasurementVM);
      //this.measurementPointUpdated.emit();
      // if (!this.system.ShowHideCRoller) {
      //   this.system.Components = this.system.Components.filter(
      //     (component) => component.ComponentTypeId !== 234
      //   );
      // }
      console.log("this.system", this.system)
      this.system.Components.map(x => {
        x.isExcludeC = false;
        if (this.EvalautionRange != null) {
          if (x.ComponentTypeId == 230) {
            if (this.EvalautionRange.LinkC == null) x.isExcludeC = true;
            else x.isExcludeC = false;


            if (x.Tool == "Eval") {
              console.log("EVALLL____")
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }

          }
          if (x.ComponentTypeId == 231) {
            if (this.EvalautionRange.BushC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 232) {
            if (this.EvalautionRange.ShoeC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 233) {
            if (this.EvalautionRange.IdlerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 234) {
            if (this.EvalautionRange.CarrierRollerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 235) {
            if (this.EvalautionRange.TrackRollerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 236) {
            if (this.EvalautionRange.SprocketC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 240) {
            if (this.EvalautionRange.ElongationC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 417) {
            if (this.EvalautionRange.CrawlerGuideC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
          if (x.ComponentTypeId == 446) {
            if (this.EvalautionRange.RSRearIdlerC == null) x.isExcludeC = true;
            else x.isExcludeC = false;

            if (x.Tool == "Eval") {
              this.changeEval_(x.EvalCode, x.InspectionDetailId, x.ComponentTypeId);
            }
          }
        }
        this._cdr.detectChanges();
      })
    });

  }

  UpdateComponentMeasurementRefreshInperp(InspectionMeasurement: InspectionMeasurementVM) {
    this._interp.UpdateComponentMeasurementRefreshInperp(InspectionMeasurement).subscribe(r => {
      if (r = true) {
        //  this._notify.success('Update Success');
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }


  showPosition(position: number, compartTypeId: number): string {
    let hasSameComponent = this.system.Components.filter(x => x.ComponentTypeId == compartTypeId && x.IsChild == false);
    if (hasSameComponent.length > 1) {
      return this.getPositionStringDoubleComponents(position, compartTypeId);
    } else {
      return this._app.getPositionString(position, compartTypeId);
    }
    // if(this.system.Components.length >4){
    //         return this.getPositionStringDoubleComponents(position,compartTypeId);
    // }else{
    //     return this._app.getPositionString(position, compartTypeId);
    // }

  }

  getPositionStringDoubleComponents(Pos: number, CompartTypeId: number): string {
    if (CompartTypeId === 233) // Idler
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';
    if (CompartTypeId === 234 && Pos === 1) // Carrier roller
      return 'Front';
    if (CompartTypeId >= 230 && CompartTypeId <= 232 || CompartTypeId === 236 || CompartTypeId === 237 || CompartTypeId === 240) {// Link, Bushing, Shoe, Sprocket
      if (Pos === 1) return 'Front'; else if (Pos === 2) return 'Rear';

    }
    if (CompartTypeId == 446)
      return 'Rear'
    return Pos.toString();
  }

  changeEval(selectedEval: string, inspectionDetailId: number, compType: number, toolId: number = 0) {
    if (toolId == toolType.ConditionAssessment) {
      compType = 0;
      toolId == toolType.ConditionAssessment;
      selectedEval = selectedEval == 'Good' ? 'A' : selectedEval == 'Monitor' ? 'B' : selectedEval == 'Failed' ? 'X' : 'U';
    } else {
      toolId == toolType.Eval;
    }
    //const measurement =  this._appService.getEvalToolMeasurementPoint(selectedEval);
    const measurement = this._appService.getEvalToolMeasurementPoint_Worn(selectedEval, compType, this.EvalautionRange, this.isEnableMaxRange);
    //console.log("Measureemt", measurement)
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, toolId, this.EvalautionRange, null);
    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        this.loadSystem();
        this.measurementPointUpdated.emit();
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }

  changeEval_(selectedEval: string, inspectionDetailId: number, compType: number) {
    //const measurement =  this._appService.getEvalToolMeasurementPoint(selectedEval);
    const measurement = this._appService.getEvalToolMeasurementPoint_Worn(selectedEval, compType, this.EvalautionRange, this.isEnableMaxRange);
    //console.log("Measureemt", measurement)
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, 9, this.EvalautionRange, null);
    // this._interp.updateComponentMeasurement(m).subscribe(r => {
    //   if (r.m_Item1) {
    //     this.measurementPointUpdated.emit();

    //   } else {

    //   }
    // }, err => {

    //   console.error(err);
    // });
  }
  loadQuotes() {
    this._quotes.getQuoteOverviewsAndReloadIfFirst(this.inspectionId).subscribe(r => {
      this.quotes = r;
    });
  }

  loadComment(component: ComponentModel) {
    this._interp.GetComponentComment(this.inspectionId, component.InspectionDetailId).subscribe(res => {
      if (res.m_Item1 == true) {
        component.Comment = res.m_Item2;
        this.updateComment = res.m_Item2;
      }
    })
    component.Comment = this.updateComment;

    this.ComponentCommentUpdated.emit();

  }


  loadPhoto(component: ComponentModel) {
    this._interp.getComponentPhotoList(component.InspectionDetailId, this.inspectionId).subscribe(res => {
      component.ComponentImages = [];
      if (res.photo1 != null) {
        component.PhotoThumbnail = res.photo1;

        component.ComponentImages.push({
          Id: res.photoId1,
          InspectionDetailId: component.InspectionDetailId,
          ComponentImageUrl: res.photo1,
          InspectionId: this.inspectionId
        },
          {
            Id: res.photoId2,
            InspectionDetailId: component.InspectionDetailId,
            ComponentImageUrl: res.photo2,
            InspectionId: this.inspectionId
          },
          {
            Id: res.photoId3,
            InspectionDetailId: component.InspectionDetailId,
            ComponentImageUrl: res.photo3,
            InspectionId: this.inspectionId
          },
          {
            Id: res.photoId4,
            InspectionDetailId: component.InspectionDetailId,
            ComponentImageUrl: res.photo4,
            InspectionId: this.inspectionId
          },
          {
            Id: res.photoId5,
            InspectionDetailId: component.InspectionDetailId,
            ComponentImageUrl: res.photo5,
            InspectionId: this.inspectionId
          })
      } else {
        component.PhotoThumbnail = '';
      }
    })
  }

  loadSystemImages(c) {
    let SystemId = c.SystemId;
    let imageUrl = c.imagePath;
    this.systemId = SystemId;
    this.loadSystem();
  }

  componentHasRecommendation(componentId: number): boolean {
    const quote = this.quotes.find(q => q.QuoteId === this.selectedQuoteId);
    if (quote == null)
      return false;
    const recommendation = quote.Recommendations.find(q => q.ComponentId === componentId);
    if (recommendation != null)
      return true;
    return false;
  }

  componentRecommendationId(componentId: number): number {
    const quote = this.quotes.find(q => q.QuoteId === this.selectedQuoteId);
    if (quote == null)
      return 0;
    const recommendation = quote.Recommendations.find(q => q.ComponentId === componentId);
    if (recommendation != null)
      return recommendation.RecommendationId;
    return 0;
  }

  get panelHeading() {
    if (this.loadingSystems)
      return '';
    return this.systemSide + ' Side ' + this.systemName;
  }
  getMeasurement(event: any, c: ComponentModel) {
    //console.log("event__123 ", event.target.value)
    return c.Measurement;
  }
  /**
   * Updates a component measurement with the new measurement given.
   * Will reload the table with the data after saving successfully.
   * @param measurement The new measurement (in mm or inches, depending on the users preference)
   * @param inspectionDetailId The inspection detail id to update the measurement for
   */
  public updateComponentMeasurement(measurement: number, inspectionDetailId: number, event: any, component: ComponentModel) {
    if (event != null) {
      measurement = event.target.value;
    }
    else {
      measurement = measurement;
    }
    //console.log("event____11111", event.target.value)
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, -1, this.EvalautionRange, 7);

    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        //this.loadSystem();
        this.measurementPointUpdated.emit();
        this.loadSelectedComponentMeasurement(component, inspectionDetailId);
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }


  loadSelectedComponentMeasurement(component: ComponentModel, inspectionDetailsId: number) {
    this._interp.GetComponentMeasurement(this.inspectionId, inspectionDetailsId).subscribe(res => {
      if (res != null) {
        component.WornPercentage = res.WornPercentage;
        component.EvalCode = res.EvalCode;
        component.Measurement = res.Measurement;

        console.log("this.system", this.system.Components)

        this.system.Components.map(x => {
          if (x.ComponentId == res.ParentComponentId) {
            console.log("this.xx", x)
            x.WornPercentage = res.ParentWornPercentage;
          }
        })
        //console.log(component)
      }
    })
  }
  //onPress flag
  onClickFlag(component) {


    this.removeFlagPopup == false ? this.removeFlagPopup = true : this.removeFlagPopup = false

    this.flag_comment = component.flag_comment
    this.flag_on = component.flag_on
    this.selected_inspection_detail_auto = component.InspectionDetailId
    this.selected_track_unit_auto = component.ComponentId
  }

  onClickRemoveFlag() {


    this._interp.updateComponentFlag(this.inspectionId, this.selected_inspection_detail_auto, this.selected_track_unit_auto).subscribe(r => {

      this.removeFlagPopup = false
      this.loadSystem();
      this.measurementPointUpdated.emit();
      this._notify.success('Flag Updated');
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }

  onClickCloseFlag() {
    this.removeFlagPopup = false
    this.flag_comment = ""
    this.flag_on = false
    this.selected_inspection_detail_auto = 0
    this.selected_track_unit_auto = 0
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }
  // load Overall Eval
  loadOverallEval() {
    this._interp.getOverallEval(this.inspectionId).subscribe(overallEval => {
      this.overallEval = overallEval;
      this.loadSystem();
    }, err => this.handleError(err, 'Can\'t get the overall evaluation. '));
  }


  public updateComponentTool(measurement: number, inspectionDetailId: number, toolId: number) {
    const m = new UpdateComponentMeasurementModel(this.inspectionId, inspectionDetailId, measurement, this.unitOfMeasurement, toolId, this.EvalautionRange, null);
    if (toolId === toolType.Eval || toolId == toolType.ConditionAssessment) m.Measurement = 30;
    this._interp.updateComponentMeasurement(m).subscribe(r => {
      if (r.m_Item1) {
        this.loadSystem();
        this.measurementPointUpdated.emit();
        this._notify.success('Updated', r.m_Item2);
      } else {
        this._notify.error('Failed', 'Unable to update component measurement. ');
        console.error(r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to update component measurement. ');
      console.error(err);
    });
  }

  get systemName(): string {
    switch (this.system.Type) {

      case UCSystemType.Chain:
        return 'Chain';
      case UCSystemType.Frame:
        return 'Frame';
      default:
        return 'Chain';
    }
  }

  /**
  * Gets the name of the side of the equipment that
  * this system is on.
  * @returns The side of the system.
  */
  get systemSide(): string {
    switch (this.system.Side) {
      case Side.Unknown: return 'Unknown';
      case Side.Both: return 'Both';
      case Side.Left: return 'Left';
      case Side.Right: return 'Right';
    }
  }

  /**
   * Gets the abbreviate unit of measurement the current user has
   * set. It is based off what they have selected in
   * their user preferences.
   * @returns The abbreviation of milimeters or inches.
   */
  get unitOfMeasurementShort(): string {
    switch (this.unitOfMeasurement) {
      case MeasurementType.Milimeter:
        return 'mm';
      case MeasurementType.Inch:
        return 'in';
      default:
        return '?';
    }
  }

  /**
   * Gets the current unit of measurement the logged in user
   * has set.
   */
  get unitOfMeasurement(): MeasurementType {
    if (this.system != null && this.system.Components.length > 0)
      return this.system.Components[0].MeasurementType;
    return MeasurementType.Milimeter;
  }

  sanitize(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(image);
  }

  sanitize_PI(image: string) {
    if (image != null) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);

    }
  }

  /**
   * Gets the component from the given Id.
   * @param componentId The ID component we want to get.
   * @returns The component model.
   */
  getComponent(componentId: number): ComponentModel {
    return this.system.Components.find(c => c.ComponentId === componentId);
  }

  /**
   * Determines if the child component row displayed in the table is in the first
   * position, somewhere in the middle of the list, or in the last position.
   * We need to know this so we can determine how to draw the lines that connect
   * the child components to the parent to indicate they are children to the user.
   * @param componentId The Id of the component we are drawing the row for.
   * @returns The css class extension to draw the correct line based on the position.
   */
  getChildRowPosition(componentId: number): string {
    const component = this.getComponent(componentId);
    //const children = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId && c.IsChild);
    const children = this.system.Components.filter(c => c.ParentComponentId === component.ParentComponentId);
    if (children.length > 0) {
      if (children[children.length - 1].ComponentId === componentId) return '--half';
      else if (children[0].ComponentId === componentId) return '--extended';
    }
    return '';
  }

  /**
   * Checks if the given component Id is a parent component. Returns true if the component
   * is a parent.
   * @param componentId The id of the component we want to know is a parent or child.
   */
  isParent(componentId: number): boolean {
    const children = this.system.Components.filter(c => c.ParentComponentId === componentId && c.IsChild);
    if (children.length > 0) return true;
    return false;
  }

  handleError(error, message: string) {
    this._notify.error('Error', message);
    console.error(error);
    this._loading.finishedLoading();
  }


  getImage_(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }


  getFamilyDetails(value: string) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res
        familydetails.map(x => {
          if (x.typedesc == value) {
            this.FamilyImage_Chain = x.ChainImage
            this.FamilyImage_Frame = x.FrameImage
          }
        })
      }
    })
  }

  updateComponentComment(inspectionId: number, inspectionDetailId: number, comment: string) {
    this._interp.updateComponentComment(this.inspectionId, inspectionDetailId, comment).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Saved', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2, r.m_Item2);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
    });
  }

  EditSerial(sys: SystemModel) {
    const editSeralNumber = this._dialog.open(EditSystemSerialNumberComponent, {
      data: {
        SerialNumber: sys.SerialNumber,
        systemId: sys.Id,
      }
    });
    editSeralNumber.afterClosed().subscribe(details => {
      if (details == true) {
        this._interp.GetSystemSerial(sys.Id).subscribe(res => {
          sys.SerialNumber = res;
        })
        //this._quotes.reloadQuoteOverview(this.inspectionId);
        //this.loadSystem();
        //this.reloadSelectedQuote.emit(details)
      }
    });
  }

  showMultipleMeasurements(component: ComponentModel) {
    const editSeralNumber = this._dialog.open(ViewMultipleMeasurementsComponent, {
      data: {
        MeasurementList: component.multipleMeasurements,
        ComponentTypeId: component.ComponentTypeId,
        UOM: this.unitOfMeasurement,
        EvalRange: this.EvalautionRange,
        ToolId: component.ToolId
      }
    });
    editSeralNumber.afterClosed().subscribe(details => {
      if (details && component.ComponentTypeId == 231) {
        this.loadSelectedComponentMeasurement(component, component.InspectionDetailId);
      }
    });
  }

  OpenFlaggedComponent(component: ComponentModel) {
    const editSeralNumber = this._dialog.open(ViewFlaggedComponentInfoComponent, {
      data: {
        InspectionDetailId: component.InspectionDetailId,
        ComponentId: component.ComponentId,
        componentTypeId: component.ComponentTypeId,
        FlaggedInfo: component.FlaggedInfo,
      }
    });
    editSeralNumber.afterClosed().subscribe(details => {
      if (details) {
        this.loadSystem();
        this.reloadFlaggedComponents.emit();
      }
    });
  }
  resetFlaggedComponent(component: ComponentModel) {
    this._interp.setFlaggedComponentActionTaken(component.FlaggedInfo.InspectionId, component.FlaggedInfo.Id, false, false).subscribe(res => {
      if (res) {
        this.loadSystem();
        this.reloadFlaggedComponents.emit();
        this._notify.success('Update', "Flagged component ready to record action.");
      } else {
        this._notify.error('Failed', "Error while updating flagged component.");
      }
    })
  }


  editSysBudgetLife(type: number) {
    this.editableSystemBudgetLife = true;
  }
  onSaveSysBudgetLife(Id: number, BudgetLife: number) {
    this.editableSystemBudgetLife = false;
    this.UpdateBudgetLife(Id, BudgetLife);
  }
  onCancelSysBudgetLife() {
    this.editableSystemBudgetLife = false;
  }
  editSysBudgetDistance(type: number) {
    this.editableSysBudgetDistance = true;
  }
  onSaveSysBudgetDistance(Id: number, BudgetDistance: number) {
    this.editableSysBudgetDistance = false;
    this.UpdateBudgetDistance(Id, BudgetDistance);
  }
  onCancelSysBudgetDistance() {
    this.editableSysBudgetDistance = false;
  }

  UpdateBudgetLife(Id: number, BudgetLife: number) {
    this._interp.UpdateBudgetLife(Id, BudgetLife, ScreenCode.IP).subscribe(res => {
      if (res) {
        this._notify.success("Budget Life updated successfully")
      } else {
        this._notify.error("Error while updating Budget Life, Please contact Tracktreads Support")
      }
    })
  }

  UpdateBudgetDistance(Id: number, BudgetDistance: number) {
    this._interp.UpdateBudgetDistance(Id, BudgetDistance, ScreenCode.IP).subscribe(res => {
      if (res) {
        this._notify.success("Budget Distance updated successfully")
      } else {
        this._notify.error("Error while updating Budget Distance, Please contact Tracktreads Support")
      }
    })
  }

  updateSystemCondition(system: SystemModel, newValue: string) {
    if (!this.isInspector)
      return;
    this._interp.updateSystemCondition(system.Id, newValue).subscribe(r => {
      if (r.m_Item1) {
        system.SystemCondition = newValue;
        system.SystemConditionColor = r.m_Item2;
        this._notify.success("Frame Condition updated successfully")
      } else {
        this._notify.error("Error while updating Frame Condition, Please contact Tracktreads Support")
      }
    })
  }

  getSystemLife() {
    this._interp.getSystemLife(this.system.Id).subscribe(res => {
      this.system.LifeLived = res;
    })
  }

  getSystemDOC() {
    this._interp.getSystemDOC(this.system.Id).subscribe(res => {
      this.system.LifeLivedKm = res;
    })
  }

  ngAfterViewInit() {

  }
  //TT-9235
  getUserUOD() {
    this._pref.getGeneralTabPreferences().subscribe(res => {
      this.userUOD = res.UnitofDistance;
      this.userUOM = res.UnitOfMeasurementName;
    })
  }

  // to convert distance from kilometers to miles for display purpose
  convertDistanceKmToMi(distance: number): number {
    return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }

}
